import {getStoryBySlug} from "../story/requests";
import { GlobalSettings } from "./entities";

const getGlobalSettings = () => getStoryBySlug("global-setting").then(GlobalSettings);

export {getGlobalSettings}
